/**
 * Exceldownload working with NSWOW2 Tables
 */
class XTableNamer {
  constructor() {

    const elements = Array.prototype.slice.call(document.querySelectorAll('.content .ns-table-wrap, .content .ns-title-h1, .content .ns-title-h2, .content .ns-title-h3, .content .ns-title-h4, .content .accordion__title'));

    let h1;
    let h2;
    let c;
    const pageTitle = document.querySelector('.header__top-title');

    elements.forEach(element => {
      const className = element.classList[0];


      switch(className) {
        case "ns-title-h1":
          const span = element.querySelector('.ns-title-h1 > span:last-child:not(.ns-title-h1__audited)');
          if(!!span){
            h1 = span.innerText;
          }
          c = 0;
          break;
        case "ns-title-h2":
          if(!!element.innerText.trim()){
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "ns-title-h3":
          if(!!element.innerText.trim()){
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "ns-title-h4":
          if(!!element.innerText.trim()){
            h2 = element.innerText;
            c = 0;
          }
          break;
        case "accordion__title":
          const spanL = element.querySelector('span:last-child');
          if(!!spanL && !!spanL.innerText.trim()){
            h2 = spanL.innerText;
            c = 0;
          }
          break;
        case "ns-table-wrap":
          let title = '';
          let fileTitle = '';
          if(!!pageTitle){
            title += pageTitle.innerText;
          }
          if(!!h1){
            if(!!pageTitle){
              title += ' – ';
            }
            title += h1.trim();
          }
          if(!!h2){
            if(!!h1 || !!pageTitle){
              title += ' – ';
            }
            title += h2.trim();
            fileTitle += h2.replace(/[^A-Za-z_ ]+/g, '').trim().replace(/\s/g, '_');
          } else{
            fileTitle += h1.replace(/[^A-Za-z_ ]+/g, '').trim().replace(/\s/g, '_');
          }
          if(c > 0){
            title += ' ' + (c + 1);
            fileTitle += '_'+(c + 1);
          }

          title = title.replace(/[^A-Za-züäö ]+/g, '').trim();

          element.dataset.xTitle = title;
          element.dataset.xFileTitle = fileTitle;
          element.querySelector('table').dataset.xTitle = title;
          element.querySelector('table').dataset.xFileTitle = fileTitle;
          c++;
          break;
      }
      // ifelement.
    });
  }
}
export default XTableNamer;
